import { render, staticRenderFns } from "./setting-join-wxapp.vue?vue&type=template&id=6387dbf7&"
import script from "./setting-join-wxapp.vue?vue&type=script&lang=js&"
export * from "./setting-join-wxapp.vue?vue&type=script&lang=js&"
import style0 from "./setting-join-wxapp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports